<template lang="pug">
  div
    label(class='u-mb1 u-block' v-if='label') {{label}}

    div(class='u-12/12', :class='wrapperClass')
      select(:value='value', :class='selectClass' ref='input' @change='updateValue($event.target.value)')
        option(:value='0' hidden disabled) {{placeholder}}
        option(v-for='option in options', :value='option.id' class='u-color-default') {{option.name}}
      i(class='u-icon' v-if='icon') {{icon}}
      i(class='u-icon caret_down')

    span(class='u-pt1 u-fz-h6 u-pl1 u-block', :class='errorClass' v-if='isShowMessage') {{message}}
</template>

<script>
  import Validator from 'validatorjs'

  export default {
    props: {
      validation: Boolean,
      wrapperClass: String,
      icon: String,
      placeholder: {
        type: String,
        default: 'Seleccione'
      },
      options: {
        type: Array,
        default: []
      },
      errorClass: {
        type: String,
        default: 'u-color-error'
      },
      rule: {
        type: String,
        default: 'min:1'
      },
      selectClass: String,
      value: Number,
      label: String,
      message: {
        type: String,
        default: 'Seleccione una opción'
      }
    },

    data () {
      return {
        isShowMessage: false,
        validated: false
      }
    },

    methods: {
      updateValue (value) {
        this.validate()
        this.$emit('input', parseInt(value, 10))
      },

      validate () {
        if (this.rule) {
          let validate = new Validator({value: parseInt(this.$refs.input.value, 10)}, {value: this.rule})
          this.validated = validate.passes()
          this.isShowMessage = validate.errors.first('value')
        }
      }
    },

    watch: {
      validation (val, oldVal) {
        this.validate()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/SelectValidate.vue